import List from '../../views/Contexto/List';
import Form from '../../views/Contexto/Form';
import { __ADMINISTRADOR } from '../../security/RoleConfiguration';

export const path = '/admin/contexto';

export const listRoutes = [
    {
        path: path + '/listagem',
        component: List,
        roles: [ __ADMINISTRADOR ],
    },
    {
        path: path + '/:id/editar',
        component: Form,
        roles: [ __ADMINISTRADOR ],
    }
];

export default listRoutes;